import ProductIndex from "../pages/product/main product/productIndex";
import AddProduct from "../pages/product/main product/addProduct";
import ProductVariationIndex from "../pages/product/ProductsPage";
import AddVariationProduct from "../pages/product/AddProductPage";
import EditProductVariation from "../pages/product/EditProductPage";
import ProductsPage from "../pages/product/main product/productIndex";
import EditProduct from "../pages/product/main product/editProduct";

const productRoutes = [
  {
    path: "products",
    element: <ProductsPage />,
  },
  {
    path: "products/add",
    element: <AddProduct />,
  },
  {
    path: "products/edit/:id",
    element: <EditProduct />,
  },
  {
    path: "productsVariation",
    element: <ProductVariationIndex />,
  },
  {
    path: "productsVariation/add/:productId?",
    element: <AddVariationProduct />,
  },
  {
    path: "productsVariation/edit/:id",
    element: <EditProductVariation />,
  },
];

export default productRoutes;